"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Button_1 = require("../Button");
const Icon_1 = require("../Icon");
// styles
require("./accordion.scss");
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-accordion-content",
};
const AccordionContent = (_a) => {
    var { className, headerClassName, panelClassName, title, titleElement, headerComponent, children, open, disabled, onClick, clickableHeader, outlined } = _a, rest = __rest(_a, ["className", "headerClassName", "panelClassName", "title", "titleElement", "headerComponent", "children", "open", "disabled", "onClick", "clickableHeader", "outlined"]);
    const classList = (0, classnames_1.default)("tecma-accordion-content", className);
    const headerClassList = (0, classnames_1.default)("tecma-accordion-content-header", { disabled }, { "clickable-header": clickableHeader }, { open }, { outlined }, headerClassName);
    const panelClassList = (0, classnames_1.default)("tecma-accordion-content-panel", { open }, panelClassName);
    const contentRef = (0, react_1.useRef)(null);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classList }, rest, { children: [headerComponent ||
                (clickableHeader ? ((0, jsx_runtime_1.jsxs)("button", Object.assign({ type: "button", className: `${headerClassList} custom-button`, onClick: onClick, disabled: disabled }, { children: [(0, jsx_runtime_1.jsx)(Icon_1.Icon, { iconName: "arrow-down", size: "small", className: "icon" }), title && (0, jsx_runtime_1.jsx)("h2", { children: title }), titleElement] }))) : ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: headerClassList }, { children: [(0, jsx_runtime_1.jsx)(Button_1.Button, { size: "small", iconName: "arrow-down", transparent: true, disabled: disabled, onClick: onClick || (() => { }) }), title && (0, jsx_runtime_1.jsx)("h2", { children: title }), titleElement] })))), (0, jsx_runtime_1.jsx)("div", Object.assign({ ref: contentRef, "data-testid": "tecma-accordion-content-panel", className: panelClassList }, { children: children }))] })));
};
AccordionContent.defaultProps = defaultProps;
exports.default = react_1.default.memo(AccordionContent);
